/*  React  */
import { Tenant } from 'application/Shared/types/tenant';
import React, { createContext, useContext, useMemo } from 'react';

export interface ClientsTableContextProps {
    partnerTenant: Tenant;
}

export const ClientsTableContext = createContext<
    ClientsTableContextProps | undefined
>(undefined);

export interface ClientsTableContextProviderProps {
    children: React.ReactNode;
    partnerTenant: Tenant;
}

export const ClientsTableContextProvider = ({
    children,
    partnerTenant
}: ClientsTableContextProviderProps) => {
    const providerValues = useMemo(
        () => ({
            partnerTenant
        }),
        [partnerTenant]
    );

    return (
        <ClientsTableContext.Provider value={providerValues}>
            {children}
        </ClientsTableContext.Provider>
    );
};

export const useClientsTableContext = () => {
    const context = useContext(ClientsTableContext);

    if (context === undefined) {
        throw new Error(
            '`useClientsTableContext` must be used within `ClientsTableContextProvider`'
        );
    }

    return context;
};
